/** Limite máximo para uploads ao Supabase Storage (5 MB) */
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_FILE_SIZE_MB = 5;

/**
 * Limite máximo para uploads ao Cloudflare R2 (5 TB — máximo suportado pelo R2).
 * Sem limite prático para uso normal; validação impede apenas objetos acima do limite do provedor.
 */
const R2_MAX_TB = 5;
export const R2_MAX_FILE_SIZE_BYTES = R2_MAX_TB * 1024 * 1024 * 1024 * 1024;
export const R2_MAX_FILE_SIZE_MB = R2_MAX_TB * 1024 * 1024;

/**
 * Retorna o limite de tamanho aplicável ao arquivo:
 * - Arquivos > MAX_FILE_SIZE_BYTES → R2_MAX_FILE_SIZE_BYTES
 * - Demais                         → MAX_FILE_SIZE_BYTES
 */
export function limitePorStorage(fileSize: number): {
  limite: number;
  storage: "supabase" | "r2";
} {
  if (fileSize > MAX_FILE_SIZE_BYTES) {
    return { limite: R2_MAX_FILE_SIZE_BYTES, storage: "r2" };
  }
  return { limite: MAX_FILE_SIZE_BYTES, storage: "supabase" };
}
